/* * @Author: Wei Guojun * @Date: 2021-04-12 09:43:37 * @Last Modified by: WeienuList
Guojun * @Last Modified time: 2022-02-10 15:44:18 */
<template>
  <div class="mainBody">
    <div class="header">账号信息</div>
    <div class="infoBox">
      <div class="top">
        <div class="ImgBox">
          <img :src="averter" />
        </div>
        <div class="nTelAdress">
          <p>昵称：{{ name }}</p>
          <p>
            账号：{{ detailInfo.account_id
            }}<span class="setPsd" @click="dialogFormVisible = true"
              >设置登录密码</span
            >
          </p>
          <p>联系方式：{{ detailInfo.phone }}</p>
        </div>
      </div>
      <div class="bottom">
        <div class="xyForm">
          <div class="formList">
            <div class="subTitle formItem">
              <div class="leftIcon"></div>
              寄件人实名信息
              <div class="editBox" @click="setRealname">
                <img src="@/assets/images/edit-f.png" />
              </div>
            </div>
            <div class="formItem">
              <div class="itemLeft pL20">姓 名 :</div>
              <div>{{ detailInfo.name }}</div>
            </div>
            <!-- <div class="formItem">
              <div class="itemLeft">联系方式 :</div>
              <div>{{ detailInfo.phone }}</div>
            </div> -->
            <div class="formItem">
              <div class="itemLeft pL20">身份证号 :</div>
              <div>{{ detailInfo.number }}</div>
            </div>
            <div class="subTitle">
              <div class="leftIcon"></div>
              商户信息
            </div>
            <div class="formItem">
              <div class="itemLeft pL20">公司名称 :</div>
              <div>{{ detailInfo.company }}</div>
              <div class="editBox" @click="nameEdit">
                <img src="@/assets/images/edit-f.png" />
              </div>
            </div>
            <div class="formItem pL20">
              <div class="itemLeft" style="width: 140px">
                预定日最高打单量 :
              </div>
              <div>{{ detailInfo.estimate_day_order_num }}  <i class="el-icon-question " style="color: #409EFF;" @click="goerrorTip"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 设置登录密码 -->
    <el-dialog
      title="设置登录密码"
      :visible.sync="dialogFormVisible"
      width="420px"
    >
      <el-form :model="ruleForm" :rules="rules" status-icon ref="passForm">
        <el-form-item label="登录密码" prop="pass">
          <el-input
            :type="passwordType"
            v-model="ruleForm.pass"
            placeholder="请输入密码（6-20个英文字符/数字/特殊符号）"
            autocomplete="new-password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="再次输入" prop="checkPass">
          <el-input
            :type="passwordType"
            v-model="ruleForm.checkPass"
            autocomplete="new-password"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePsd">保 存</el-button>
      </div>
    </el-dialog>
    <component
      :is="curComponent[0]"
      :ref="curComponent[1]"
      @triggerEvent="curComponent[2]"
    ></component>
  </div>
</template>
<script>
import util from "@/util/util";
import face from "@/api/face";
export default {
  name: "faceSheet",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入登录密码！"));
      } else {
        if (value.length >= 6 && value.length <= 20) {
          callback();
        } else {
          callback(new Error("密码不符合6-20个字符规范，请重新输入！"));
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入！"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入的密码不一致！"));
      } else {
        callback();
      }
    };
    return {
      averter: "",
      name: "",
      // phone: "",
      detailInfo: {},
      dialogFormVisible: false,
      passwordType: "password",
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [
          {
            required: true,
            validator: validatePass,
          },
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "change" },
        ],
      },
      curComponent: [],
    };
  },
  watch: {
    dialogFormVisible: {
      handler(val) {
        if (!val) {
          this.$refs.passForm.resetFields();
        }
      },
      immediate: false,
    },
  },
  methods: {
    //获取用户信息
    getinfo() {
      // console.log(util.getCookie("nickname"));
      this.name = util.getCookie("nickname");
      this.averter =
        util.getCookie("headimgurl") ||
        require(`@/assets/images/about_logo.png`);
      face.getpeoson(this).then((res) => {
        if (res.success) {
          this.detailInfo = res.data;
        }
      });
    },
    goerrorTip(){
      const Obstruct = util.getJsonValues(this.$store.state.commondict,'printObstruct')
      if(Obstruct){
        const Item = JSON.parse(Obstruct).teamAddress
        window.open(Item)
      }
    },
    nameEdit() {
      this.$prompt("公司名称", "更新公司名称", {
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        inputValue: this.detailInfo.company,
        inputPattern: /^[\u4e00-\u9fffa-zA-Z0-9]{1,15}$/,
        inputErrorMessage: "商户/公司名称应为1-15个字！",
        center: true,
      })
        .then(({ value }) => {
          if (value == this.detailInfo.company) {
            return;
          } else {
            face.updatepeoson(this, value).then((res) => {
              this.$message({ type: "success", message: "已保存成功！" });
              this.getinfo();
            });
          }
        })
        .catch(() => {});
    },
    changePsd() {
      // alert("修改密码");
      this.$refs.passForm.validate((valid) => {
        if (valid) {
          face.updatePsd(this).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "修改密码成功！" });
              this.dialogFormVisible = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    setRealname() {
      let c = () => import(`@/components/realName`);

      this.curComponent = [c, "realNameRef", this.getinfo];
    },
  },
  mounted() {
    this.getinfo();
  },
};
</script>
<style lang="stylus" scoped>
.pL20{
  padding-left: 26px
}
/* -webkit-text-security:disc;*/
.mainBody{
    padding 10px 30px
}
.header{
    font-size 16px;
    font-weight bold
    border-bottom  1px solid #DCDFE6
    line-height 50px
    color #2ea2fc
}
.infoBox{
    font-size 14px
    padding-top: 30px;
    .top{
        display flex;
        justify-content flex-start;
        padding-bottom  30px;
        margin 0 50px;
        border-bottom 4px solid #EBEEF5
        .ImgBox{
            width: 80px;
            height: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            img{
                width 100%
            }
        }
        .nTelAdress{
            padding-top:10px
            margin-left:30px
            line-height: 30px
            .setPsd{
                margin-left: 30px;
                color: #2ea2fc;
                cursor:pointer;
            }
        }
    }
    .bottom{
        padding: 10px 0;
        width: 500px;
        margin-left: 10px;
        .xyForm{
            background-color: #ffffff;
            padding: 0  40px 10px 40px;
            font-size: 14px;
        }
        .subTitle{
            padding: 16px 0;
            align-items: center;
        }
        .subTitle .leftIcon{
            width: 4px;
            height: 20px;
            float: left;
            background-color: #fabe00;
            margin-right: 20px;
        }

        .formItem{
            display: flex;
            justify-content: flex-start;
            line-height 40px
        }
        .formItem .itemLeft{
            width:80px;
            height: 40px;
        }
        .formItem .editBox{
            width: 100px;
            height: 40px;
            text-align: center;
            cursor: pointer;
        }
        .subTitle .editBox{
            width: 100px;
            // height: 40px;
            text-align: center;
            cursor: pointer;
        }
        .formItem .editBox img{
            width: 20px;
            height: 20px;
            vertical-align: middle;
        }
        .formItem .inputRight{
            flex: 1;
            background-color: #F2F6FC;
            height: 60px;
            margin-right: 40px;
            padding: 0 20px;
        }
    }
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #dcdfe6;
}
</style>
